// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__Jil2J"};